import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Order from './Order';
import { isEmpty } from '../../../utils/obj-utils';
import OrdersPagination from './OrdersPagination';
import { formMessageConstants } from '../../../utils/constants/form-message-constants';
import FormMessage from '../../../common/utility/FormMessage';
import { formConstants } from '../../../utils/constants/form-constants';
import withLoadingInterval from '../../../hocComponents';

function OrdersList({
    formData = {},
    displayCancelledFiles,
    orders,
    orderTypeValues,
    numberOfPages,
    orderHistoryActivePageNumber,
    onViewFileDetailsClick,
    handleDisplayCancelledFilesChange,
    handlePageNumberChange,
    loading,
    elapsedTime
}) {
    function displayNoOrderAvailableText() {
        const { noOrdersFoundText } = formData;
        if (loading || !isEmpty(orders)) {
            return null;
        }

        return (<div className='no-files'>
            <h2>{formMessageConstants.information}</h2>
            <p className='info'>{noOrdersFoundText}</p>
        </div>);
    }

    function displayLoadingError() {
        const errorMessage = formData[formConstants.loadingErrorMessage];
        if (!errorMessage) {
            return null;
        }
        return <FormMessage
            isSuccessMessage={false}
            messages={[errorMessage]}/>;
    }

    function displayOrderList() {
        if (loading || isEmpty(orders)) {
            return null;
        }

        const { fileState } = formData;
        return orders.map((orderHistoryItem, index) => {
            return (<Order
                key={index}
                orderTypeValues={orderTypeValues}
                orderItem={orderHistoryItem}
                fileStateValues={fileState}
                onViewFileDetailsClick={onViewFileDetailsClick}></Order>);
        });
    }

    function displayPagination() {
        if (loading || isEmpty(orders)) {
            return null;
        }

        if (numberOfPages <= 1) {
            return null;
        }

        return <OrdersPagination
            numberOfPages={numberOfPages}
            activePageNumber={orderHistoryActivePageNumber}
            onPageNumberChange={handlePageNumberChange}></OrdersPagination>;
    }

    const elapsedTimeLimit = formData[formConstants.elapsedTimeLimit];

    return (
        <Fragment>
            <div className='display-files'>
                <p>{formMessageConstants.display}:</p>
                <label className='form-switch'>
                    <input
                        checked={displayCancelledFiles}
                        onChange={handleDisplayCancelledFilesChange}
                        type='checkbox' />
                    <i></i>{formMessageConstants.canceledFiles}
                </label>
            </div>
            <div className='category order-history'>
                {displayNoOrderAvailableText()}
                {elapsedTime > elapsedTimeLimit && displayLoadingError()}
                <div className='orders-tabs orders-list'>
                    <ul className='o-tab'>
                        {displayOrderList()}
                    </ul>
                </div>
                {displayPagination()}
            </div>
        </Fragment>
    );
}

OrdersList.propTypes = {
    formData: PropTypes.object.isRequired,
    displayCancelledFiles: PropTypes.bool.isRequired,
    orders: PropTypes.array.isRequired,
    orderTypeValues: PropTypes.object.isRequired,
    numberOfPages: PropTypes.number.isRequired,
    orderHistoryActivePageNumber: PropTypes.number.isRequired,
    onViewFileDetailsClick: PropTypes.func.isRequired,
    handleDisplayCancelledFilesChange: PropTypes.func.isRequired,
    handlePageNumberChange: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0
    };
}

export default connect(mapStateToProps)(withLoadingInterval(OrdersList));
